import Loan from '@features/Loan';

// import Loan from '@//features/Loan';
const LoanPage = () => <Loan />;

export default LoanPage;
